import type { GridRowDef } from "@juro/shared";

export function computeRowSpans(rows: GridRowDef[]): Map<string, number> {
  const spans = new Map<string, number>();

  function countLeaves(rowId: string): number {
    const children = rows.filter((row) => row.parent === rowId);
    if (children.length === 0) return 1;
    return children.reduce((sum, child) => sum + countLeaves(child.id), 0);
  }

  for (const row of rows) {
    spans.set(row.id, countLeaves(row.id));
  }

  return spans;
}

export function nextRowId(rows: GridRowDef[], prefix = "r"): string {
  return `${prefix}_${rows.length + 1}_${Math.random().toString(36).slice(2, 6)}`;
}
